module.exports = __webpack_public_path__ + "img/dahsing.3988dd9a.png";